module.exports = __webpack_public_path__ + "img/login-bg.cc8c42a9.png";